import * as React from 'react';

import { createIcon } from '../Icon';
export const MoveVerticalIcon = createIcon(
  <path d="m16 3l4 4l-4 4m4-4H4m4 14l-4-4l4-4m-4 4h16" />,
  'MoveVerticalIcon'
);
